"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueEstimation = exports.RevenueEstimationResult = exports.RevenueEstimationResultType = void 0;
const infrastructure_1 = require("../../../infrastructure");
const validator_1 = require("@leavy/validator");
const Address_1 = require("../../../common/domain/Address");
const utils_1 = require("@leavy/utils");
const MultiCurrencyMoney_1 = require("@leavy/lv-homesharing-pricing-srv/lib/money/model/MultiCurrencyMoney");
var RevenueEstimationResultType;
(function (RevenueEstimationResultType) {
    RevenueEstimationResultType["PER_DAY"] = "PER_DAY";
    RevenueEstimationResultType["FOR_PERIOD"] = "FOR_PERIOD";
})(RevenueEstimationResultType = exports.RevenueEstimationResultType || (exports.RevenueEstimationResultType = {}));
class RevenueEstimationResult extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    get hasExpired() {
        return new Date() > new Date(this.maxValidityDate);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => MultiCurrencyMoney_1.MultiCurrencyMoneyModel),
    __metadata("design:type", Object)
], RevenueEstimationResult.prototype, "value", void 0);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RevenueEstimationResult.prototype, "hasExpired", null);
exports.RevenueEstimationResult = RevenueEstimationResult;
class RevenueEstimation extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    hasBaseAccommodationInfo() {
        return (utils_1.Guard.isNotNullish(this.bedrooms) && this.bedrooms >= 0
            && utils_1.Guard.isNotNullish(this.maxOccupancy) && this.maxOccupancy > 0
            && utils_1.Guard.isNotNullish(this.address));
    }
    hasAllAccommodationInfo() {
        return (this.hasBaseAccommodationInfo()
            && utils_1.Guard.isNotNullish(this.beds) && this.beds > 0
            && utils_1.Guard.isNotNullish(this.bathrooms) && this.bathrooms >= 0);
    }
    hasPeriod() {
        return (utils_1.Guard.isNotNullish(this.departureDate)
            && utils_1.Guard.isNotNullish(this.returnDate));
    }
    hasResult() {
        return (utils_1.Guard.isNotNullish(this.result));
    }
    isComplete() {
        return (this.hasBaseAccommodationInfo()
            && this.hasResult());
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Address_1.Address),
    __metadata("design:type", Address_1.Address)
], RevenueEstimation.prototype, "address", void 0);
__decorate([
    (0, validator_1.Type)(() => RevenueEstimationResult),
    __metadata("design:type", RevenueEstimationResult)
], RevenueEstimation.prototype, "result", void 0);
exports.RevenueEstimation = RevenueEstimation;
//# sourceMappingURL=RevenueEstimation.js.map